import { FlexBox, Spinner } from '@dixa/lib-shared-habla';

export function LoadingList(): JSX.Element {
  return (
    <FlexBox
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="214px"
      borderRadius="4px"
      borderColor="neutral.200"
    >
      <Spinner />
    </FlexBox>
  );
}
